export default __webpack_public_path__ + "static/stacked-bar-1ae3340ee7fed9fb58feaaf7e055b3a3.png";